import * as React from 'react';

function SvgCoin(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#coin_svg__clip0)">
        <path
          d="M12.524 10.895c-2.194 3.359-6.213 4.527-8.955 2.735C.827 11.838.282 7.689 2.477 4.33 4.67.971 8.69-.196 11.432 1.596c2.742 1.791 3.287 5.94 1.092 9.3z"
          fill="url(#coin_svg__paint0_linear)"
          stroke="#C08E00"
          strokeWidth={0.5}
        />
        <path
          d="M11.033 10.057c-2.206 3.377-6.073 4.627-8.61 2.97-2.536-1.659-2.945-5.701-.739-9.078C3.891.572 7.757-.677 10.294.98c2.537 1.658 2.946 5.7.74 9.077z"
          fill="#FFD662"
          stroke="#C08E00"
          strokeWidth={0.5}
        />
        <path
          d="M7.014 3.758c.353-.33.975-.109 1.018.362l.126 1.38c.016.18.127.344.296.438l1.277.71c.401.222.399.756-.004.95l-1.478.717a.53.53 0 00-.291.36l-.34 1.531c-.099.443-.71.57-1.03.216l-.88-.973a.636.636 0 00-.556-.198l-1.329.187c-.484.068-.86-.41-.633-.807l.783-1.374a.506.506 0 00.024-.455l-.633-1.467c-.173-.4.188-.806.643-.724l1.45.26a.608.608 0 00.523-.146l1.034-.967z"
          fill="#C08E00"
        />
      </g>
      <defs>
        <linearGradient
          id="coin_svg__paint0_linear"
          x1={13.039}
          y1={4.985}
          x2={7.895}
          y2={12.998}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C08E00" />
          <stop offset={1} stopColor="#FFD662" />
        </linearGradient>
        <clipPath id="coin_svg__clip0">
          <path fill="#fff" d="M0 0h14.129v14.718H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgCoin;
